import type { OverviewStats } from '../../lib/calculations'

interface Props { stats: OverviewStats }

function StatCard({ label, value }: { label: string; value: string }) {
  return (
    <div className="stat-card">
      <p className="stat-label">{label}</p>
      <p className="stat-value">{value}</p>
    </div>
  )
}

function fmt(n: number) { return `NT$${n.toLocaleString()}` }
function fmtKm(n: number) { return `${n.toLocaleString()} km` }
function fmtCost(n: number | null) {
  return n == null ? '尚無里程資料' : `NT$${n.toFixed(2)}/km`
}

export default function StatsGrid({ stats: s }: Props) {
  return (
    <div className="stats-grid">
      <div className="stat-card primary">
        <div>
          <p className="stat-label">總花費</p>
          <p className="stat-value">{fmt(s.totalAmount)}</p>
        </div>
        <div style={{ textAlign: 'right' }}>
          <p className="stat-label">不含車錢</p>
          <p className="stat-value">{fmt(s.totalExcludeCar)}</p>
        </div>
      </div>
      <StatCard label="最早里程"           value={s.minOdometer > 0 ? fmtKm(s.minOdometer) : '—'} />
      <StatCard label="最新里程"           value={s.maxOdometer > 0 ? fmtKm(s.maxOdometer) : '—'} />
      <StatCard label="已騎里程"           value={s.ridden > 0 ? fmtKm(s.ridden) : '—'} />
      <StatCard label="每公里成本(不含車錢)" value={fmtCost(s.costPerKm)} />
      <StatCard label="每公里油錢"         value={fmtCost(s.fuelCostPerKm)} />
    </div>
  )
}
